export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/72a061e4da900bb3a21b7904c48e0b41.svg";